module.exports = __webpack_public_path__ + "img/hero.d622ea15.png";